/**
 * Coalesce identical in-flight GET requests (StrictMode / duplicate effects).
 * POST/PUT/PATCH/DELETE are never deduplicated.
 */

const inflightRequests = new Map();

const stableKeyPart = (value) => {
    if (value === undefined || value === null) return '';
    if (typeof value !== 'object') return String(value);
    if (Array.isArray(value)) {
        return `[${value.map(stableKeyPart).join(',')}]`;
    }
    return `{${Object.keys(value)
        .sort()
        .map((key) => `${key}:${stableKeyPart(value[key])}`)
        .join(',')}}`;
};

export const buildInflightKey = (method, url, config = {}) => {
    const parts = [
        method.toLowerCase(),
        url,
        stableKeyPart(config.params),
        config.responseType || '',
        config.withCredentials ? '1' : '0',
    ];
    return parts.join('|');
};

export const withInflightDedup = (method, requestFn) => {
    return (url, config = {}) => {
        const key = buildInflightKey(method, url, config);
        const existing = inflightRequests.get(key);
        if (existing) {
            return existing;
        }

        const promise = requestFn(url, config).finally(() => {
            inflightRequests.delete(key);
        });
        inflightRequests.set(key, promise);
        return promise;
    };
};
